export default "__VITE_ASSET__DzZg8$rN__"